import AuthService from './AuthService';

class FileService{
    constructor() {
        this.apiBaseUrl=process.env.REACT_APP_API_URL;
    }

    async getFiles(s3_path,loginAsUri){
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_path);
        const url = `${this.apiBaseUrl}/files/${encodedPath}` + loginAsUri;
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }

    async deleteFile(s3_path, documentID){
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_path);
        const response = await fetch(`${this.apiBaseUrl}/files/${encodedPath}/${documentID}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to delete file: ${documentID}`);
        }
    }

    async generatePresign(s3_path, fileData, options){
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_path);
        const response = await fetch(`${this.apiBaseUrl}/files/${encodedPath}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ files: fileData, ...(options?.requiresOcr ? { requiresOcr: true } : {}) }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json(); // Define `data` here with the JSON response
        return data;
    }

    async addUrl(s3_mapping, url, options = {}) {
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_mapping);
        const payload = { url };
        if (options.refresh) {
            payload.refresh = options.refresh;
        }
        const response = await fetch(`${this.apiBaseUrl}/files/${encodedPath}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async updateUrlRefresh(s3_mapping, documentID, refresh, url) {
        const token = AuthService.getAccessToken();
        const encodedPath = encodeURIComponent(s3_mapping);
        const response = await fetch(`${this.apiBaseUrl}/files/${encodedPath}/${documentID}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refresh, url }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }
}
const fileService = new FileService();
export default fileService;    